import { config } from './config';

const loadResource = (resource) => {
  if (!resource.platforms.includes(config.REACT_APP_PLATFORM_TYPE)) {
    return;
  }
  if (resource.enabled === false) {
    return;
  }
  const element = document.createElement(resource.tag);
  Object.keys((resource.attributes || {})).forEach((name) => {
    element.setAttribute(name, resource.attributes[name]);
  });
  if (resource.content) {
    element.appendChild(document.createTextNode(resource.content));
  }
  document.head.appendChild(element);
};

const resources = [
  {
    tag: 'script',
    attributes: {
      src: 'https://app.codox.io/plugins/wave.client.js?app=froala',
      type: 'text/javascript',
    },
    platforms: ['company'],
    enabled: true,
  },
  {
    tag: 'link',
    attributes: {
      href: 'https://cdn1.codox.io/lib/css/wave.client.css',
      rel: 'stylesheet',
    },
    platforms: ['company'],
    enabled: true,
  },
  {
    tag: 'script',
    attributes: {
      src: 'https://app.codox.io/plugins/wave.client.js?app=froala',
      modules: 'pinc.auth.min,ui.auth',
      'data-client-id': '4C4EC107-5410-4232-BCEA-C3AF54AFC070',
      'data-auth-success-url': '/pathfix/callback',
    },
    platforms: ['company'],
    enabled: true,
  },
  {
    tag: 'script',
    attributes: {
      src: '/scripts/intercom.js',
    },
    platforms: ['tester', 'company'],
    enabled: true,
  },
  {
    tag: 'script',
    attributes: {
      src: 'https://labs.pathfix.com/helper.js',
      id: 'pinc.helper',
      modules: 'pinc.auth.min,ui.auth',
      'data-client-id': '4C4EC107-5410-4232-BCEA-C3AF54AFC070',
      'data-auth-success-url': '/pathfix/callback',
    },
    platforms: ['tester'],
    enabled: true,
  },
  {
    tag: 'script',
    attributes: {
      src: '/scripts/facebook.js',
    },
    platforms: ['tester'],
    enabled: true,
  },
  {
    tag: 'noscript',
    content: `<img height="1" width="1" style="display:none"
                src="https://www.facebook.com/tr?id=285669515655728&ev=PageView&noscript=1"/>`,
    platforms: ['tester'],
    enabled: true,
  },
  {
    tag: 'script',
    attributes: {
      src: '/scripts/sessionstack.js',
    },
    platforms: ['company'],
    enabled: config.REACT_APP_ENABLE_SESSION_STACK === 'true',
  },
];

resources.forEach(loadResource);
